import {
  clearAuthenticationCookies,
  getHrAccessToken,
  getProAccessToken,
} from 'services/session/authSession'

export const hasToken = () => {
  return Boolean(getHrAccessToken() || getProAccessToken())
}

export const removeAllCookies = () => {
  clearAuthenticationCookies()
}
